module.exports = __webpack_public_path__ + "static/media/hgLogo.59e51c3c.png";